import { render, staticRenderFns } from "./AgeCheck.vue?vue&type=template&id=5b8b9cec&scoped=true&"
import script from "./AgeCheck.vue?vue&type=script&lang=js&"
export * from "./AgeCheck.vue?vue&type=script&lang=js&"
import style0 from "./AgeCheck.vue?vue&type=style&index=0&id=5b8b9cec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8b9cec",
  null
  
)

export default component.exports